import tipoIngresoService from '../services/tipoIngresoService';

export const FETCH_TIPOS_INGRESO_REQUEST = 'FETCH_TIPOS_INGRESO_REQUEST';
export const FETCH_TIPOS_INGRESO_SUCCESS = 'FETCH_TIPOS_INGRESO_SUCCESS';
export const FETCH_TIPOS_INGRESO_FAILURE = 'FETCH_TIPOS_INGRESO_FAILURE';

export const FETCH_TIPO_INGRESO_REQUEST = 'FETCH_TIPO_INGRESO_REQUEST';
export const FETCH_TIPO_INGRESO_SUCCESS = 'FETCH_TIPO_INGRESO_SUCCESS';
export const FETCH_TIPO_INGRESO_FAILURE = 'FETCH_TIPO_INGRESO_FAILURE';

export const CREATE_TIPO_INGRESO_REQUEST = 'CREATE_TIPO_INGRESO_REQUEST';
export const CREATE_TIPO_INGRESO_SUCCESS = 'CREATE_TIPO_INGRESO_SUCCESS';
export const CREATE_TIPO_INGRESO_FAILURE = 'CREATE_TIPO_INGRESO_FAILURE';

export const UPDATE_TIPO_INGRESO_REQUEST = 'UPDATE_TIPO_INGRESO_REQUEST';
export const UPDATE_TIPO_INGRESO_SUCCESS = 'UPDATE_TIPO_INGRESO_SUCCESS';
export const UPDATE_TIPO_INGRESO_FAILURE = 'UPDATE_TIPO_INGRESO_FAILURE';

export const DELETE_TIPO_INGRESO_REQUEST = 'DELETE_TIPO_INGRESO_REQUEST';
export const DELETE_TIPO_INGRESO_SUCCESS = 'DELETE_TIPO_INGRESO_SUCCESS';
export const DELETE_TIPO_INGRESO_FAILURE = 'DELETE_TIPO_INGRESO_FAILURE';

export const fetchTiposIngreso = () => async (dispatch) => {
  dispatch({ type: FETCH_TIPOS_INGRESO_REQUEST });
  try {
    const response = await tipoIngresoService.fetchTiposIngreso();
    dispatch({ type: FETCH_TIPOS_INGRESO_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_TIPOS_INGRESO_FAILURE, payload: error.message });
  }
};

export const fetchTipoIngreso = (id) => async (dispatch) => {
  dispatch({ type: FETCH_TIPO_INGRESO_REQUEST });
  try {
    const response = await tipoIngresoService.fetchTipoIngreso(id);
    dispatch({ type: FETCH_TIPO_INGRESO_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_TIPO_INGRESO_FAILURE, payload: error.message });
  }
};

export const createTipoIngreso = (tipoIngresoData) => async (dispatch) => {
  dispatch({ type: CREATE_TIPO_INGRESO_REQUEST });
  try {
    const response = await tipoIngresoService.createTipoIngreso(tipoIngresoData);
    dispatch({ type: CREATE_TIPO_INGRESO_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_TIPO_INGRESO_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};

export const updateTipoIngreso = (id, tipoIngresoData) => async (dispatch) => {
  dispatch({ type: UPDATE_TIPO_INGRESO_REQUEST });
  try {
    const response = await tipoIngresoService.updateTipoIngreso(id, tipoIngresoData);
    dispatch({ type: UPDATE_TIPO_INGRESO_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_TIPO_INGRESO_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};

export const deleteTipoIngreso = (id) => async (dispatch) => {
  dispatch({ type: DELETE_TIPO_INGRESO_REQUEST });
  try {
    await tipoIngresoService.deleteTipoIngreso(id);
    dispatch({ type: DELETE_TIPO_INGRESO_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_TIPO_INGRESO_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};